import React from "react";
import PropTypes from "prop-types";
import {useEnvValue} from "@morningtrain/react-helpers";

function WithPageTitle(props) {

    const [title, setTitle] = useEnvValue('page.title');

    React.useEffect(() => {
        setTitle(props.title);
    }, [props.title]);

    return null;
}

WithPageTitle.propTypes = {
    title: PropTypes.string.isRequired,
};

export default WithPageTitle;
